import { FC, ReactNode } from "react"
import MuiBadge, { BadgeProps as MuiBadgeProps } from "@mui/material/Badge"

export enum BadgeVariant {
   DOT = "dot",
}

export enum BadgeColor {
   HONOLULU_BLUE = "primary",
}

export interface BadgeProps {
   children: ReactNode
   variant?: BadgeVariant
   color?: BadgeColor
   invisible?: boolean
   badgeContent?: ReactNode
   className?: string
   sx?: MuiBadgeProps["sx"]
}

const Badge: FC<BadgeProps> = ({
   children,
   variant = BadgeVariant.DOT,
   color = BadgeColor.HONOLULU_BLUE,
   invisible = false,
   badgeContent,
   className,
   sx,
}) => {
   return (
      <MuiBadge
         variant={variant}
         color={color}
         invisible={invisible}
         badgeContent={badgeContent}
         className={className}
         sx={{
            "& .MuiBadge-dot": {
               width: 12,
               height: 12,
               borderRadius: "50%",
            },
            ...sx,
         }}
      >
         {children}
      </MuiBadge>
   )
}

export default Badge
